/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sales_Errors_Notfound1Inputs */

const id_sales_errors_notfound1 = /** @type {(inputs: Sales_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promosi tidak ditemukan`)
};

const ms_sales_errors_notfound1 = /** @type {(inputs: Sales_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promosi tidak ditemui`)
};

const da_sales_errors_notfound1 = /** @type {(inputs: Sales_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promotion ikke fundet`)
};

const de_sales_errors_notfound1 = /** @type {(inputs: Sales_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktion nicht gefunden`)
};

const en_us2_sales_errors_notfound1 = /** @type {(inputs: Sales_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promotion not found`)
};

const es_es2_sales_errors_notfound1 = /** @type {(inputs: Sales_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promoción no encontrada`)
};

const es_mx2_sales_errors_notfound1 = /** @type {(inputs: Sales_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promoción no encontrada`)
};

const fil_sales_errors_notfound1 = /** @type {(inputs: Sales_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi nahanap ang promosyon`)
};

const fr_sales_errors_notfound1 = /** @type {(inputs: Sales_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promotion non trouvée`)
};

const it_sales_errors_notfound1 = /** @type {(inputs: Sales_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promozione non trovata`)
};

const hu_sales_errors_notfound1 = /** @type {(inputs: Sales_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promóció nem található`)
};

const nl_sales_errors_notfound1 = /** @type {(inputs: Sales_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promotie niet gevonden`)
};

const no_sales_errors_notfound1 = /** @type {(inputs: Sales_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kampanje ikke funnet`)
};

const pl_sales_errors_notfound1 = /** @type {(inputs: Sales_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promocja nie znaleziona`)
};

const pt_br2_sales_errors_notfound1 = /** @type {(inputs: Sales_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promoção não encontrada`)
};

const pt_sales_errors_notfound1 = /** @type {(inputs: Sales_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promoção não encontrada`)
};

const ro_sales_errors_notfound1 = /** @type {(inputs: Sales_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promoție negăsită`)
};

const fi_sales_errors_notfound1 = /** @type {(inputs: Sales_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kampanjaa ei löydy`)
};

const sv_sales_errors_notfound1 = /** @type {(inputs: Sales_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kampanjen hittades inte`)
};

const vi_sales_errors_notfound1 = /** @type {(inputs: Sales_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy khuyến mãi`)
};

const tr_sales_errors_notfound1 = /** @type {(inputs: Sales_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promosyon bulunamadı`)
};

const cs_sales_errors_notfound1 = /** @type {(inputs: Sales_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promo akce nenalezena`)
};

const bg_sales_errors_notfound1 = /** @type {(inputs: Sales_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Промоцията не е намерена`)
};

const ru_sales_errors_notfound1 = /** @type {(inputs: Sales_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Акция не найдена`)
};

const uk_sales_errors_notfound1 = /** @type {(inputs: Sales_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Акцію не знайдено`)
};

const ar_sales_errors_notfound1 = /** @type {(inputs: Sales_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الترقية غير موجودة`)
};

const hi_sales_errors_notfound1 = /** @type {(inputs: Sales_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रमोशन नहीं मिला`)
};

const th_sales_errors_notfound1 = /** @type {(inputs: Sales_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบโปรโมชัน`)
};

const ja_sales_errors_notfound1 = /** @type {(inputs: Sales_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロモーションが見つかりません`)
};

const zh_cn2_sales_errors_notfound1 = /** @type {(inputs: Sales_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`促销活动未找到`)
};

const zh_hant1_sales_errors_notfound1 = /** @type {(inputs: Sales_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`促銷活動未找到`)
};

const ko_sales_errors_notfound1 = /** @type {(inputs: Sales_Errors_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프로모션을 찾을 수 없음`)
};

/**
* | output |
* | --- |
* | "Promotion not found" |
*
* @param {Sales_Errors_Notfound1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sales_errors_notfound1 = /** @type {((inputs?: Sales_Errors_Notfound1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Errors_Notfound1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sales_errors_notfound1(inputs)
	if (locale === "ms") return ms_sales_errors_notfound1(inputs)
	if (locale === "da") return da_sales_errors_notfound1(inputs)
	if (locale === "de") return de_sales_errors_notfound1(inputs)
	if (locale === "en-US") return en_us2_sales_errors_notfound1(inputs)
	if (locale === "es-ES") return es_es2_sales_errors_notfound1(inputs)
	if (locale === "es-MX") return es_mx2_sales_errors_notfound1(inputs)
	if (locale === "fil") return fil_sales_errors_notfound1(inputs)
	if (locale === "fr") return fr_sales_errors_notfound1(inputs)
	if (locale === "it") return it_sales_errors_notfound1(inputs)
	if (locale === "hu") return hu_sales_errors_notfound1(inputs)
	if (locale === "nl") return nl_sales_errors_notfound1(inputs)
	if (locale === "no") return no_sales_errors_notfound1(inputs)
	if (locale === "pl") return pl_sales_errors_notfound1(inputs)
	if (locale === "pt-BR") return pt_br2_sales_errors_notfound1(inputs)
	if (locale === "pt") return pt_sales_errors_notfound1(inputs)
	if (locale === "ro") return ro_sales_errors_notfound1(inputs)
	if (locale === "fi") return fi_sales_errors_notfound1(inputs)
	if (locale === "sv") return sv_sales_errors_notfound1(inputs)
	if (locale === "vi") return vi_sales_errors_notfound1(inputs)
	if (locale === "tr") return tr_sales_errors_notfound1(inputs)
	if (locale === "cs") return cs_sales_errors_notfound1(inputs)
	if (locale === "bg") return bg_sales_errors_notfound1(inputs)
	if (locale === "ru") return ru_sales_errors_notfound1(inputs)
	if (locale === "uk") return uk_sales_errors_notfound1(inputs)
	if (locale === "ar") return ar_sales_errors_notfound1(inputs)
	if (locale === "hi") return hi_sales_errors_notfound1(inputs)
	if (locale === "th") return th_sales_errors_notfound1(inputs)
	if (locale === "ja") return ja_sales_errors_notfound1(inputs)
	if (locale === "zh-CN") return zh_cn2_sales_errors_notfound1(inputs)
	if (locale === "zh-Hant") return zh_hant1_sales_errors_notfound1(inputs)
	return ko_sales_errors_notfound1(inputs)
});
export { sales_errors_notfound1 as "sales.errors.notFound" }